import { isMobile } from '../utils/useragent';

class Hotspot {
  public items: HTMLCollection;
  public contents: HTMLCollection;
  public closeButton: HTMLCollection;

  bindings() {
    if (this.items && isMobile()) {
      Object.values(this.items).forEach((item) => {
        item.addEventListener('click', (e: any) => {
          e.target.classList.add('o-hotspot__dot--active');
        });
        // item.addEventListener('mouseleave', (e: any) => {
        //   console.log('mouseleave hotspot');
        //   setTimeout(() => {
        //     e.target.classList.remove('o-hotspot__dot--active');
        //   }, 300);
        // });
      });
    }
    // if (this.contents) {
    //   Object.values(this.contents).forEach((item) => {
    //     item.addEventListener('mouseenter', (e: any) => {
    //       console.log('mouseenter content',e.target.previousElementSibling,e.target.previousElementSibling.previousElementSibling);
    //       e.target.previousElementSibling.previousElementSibling.classList.add('o-hotspot__dot--active');
    //     });
    //     item.addEventListener('mouseleave', (e: any) => {
    //       console.log('mouseleave content');
    //       setTimeout(() => {
    //         e.target.previousElementSibling.previousElementSibling.classList.remove('o-hotspot__dot--active');
    //       }, 300);
    //     });
    //   });
    // }
    if (this.closeButton) {
      Object.values(this.closeButton).forEach((item) => {
        item.addEventListener('click', (e: any) => {
          e.target.parentElement.previousElementSibling.classList.remove('o-hotspot__dot--active');
        });
      });
    }
  }

  cache() {
    this.items = document.getElementsByClassName('js-hotspot-toggle');
    this.contents = document.getElementsByClassName('js-hotspot-content');
    this.closeButton = document.getElementsByClassName('js-hotspot-close');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Hotspot;
